import { Component, model } from '@angular/core';

export type RidDrawingTool = { kind: 'pencil'; color: string } | { kind: 'eraser' };

export const PENCIL_WIDTH = 6;
export const ERASER_WIDTH = 32;

const PENCIL_COLORS = [
  { name: 'rood', value: '#e53935' },
  { name: 'oranje', value: '#fb8c00' },
  { name: 'geel', value: '#fdd835' },
  { name: 'groen', value: '#43a047' },
  { name: 'blauw', value: '#1e88e5' },
  { name: 'paars', value: '#8e24aa' },
  { name: 'roze', value: '#ec407a' },
  { name: 'bruin', value: '#6d4c41' },
  { name: 'zwart', value: '#212121' },
];

@Component({
  selector: 'rid-drawing-tray',
  templateUrl: './rid-drawing-tray.html',
})
export class RidDrawingTray {
  /** The selected tool, or null when nothing is picked up (so the book can be used as usual). */
  tool = model<RidDrawingTool | null>(null);

  protected readonly colors = PENCIL_COLORS;

  protected isPencilSelected(color: string): boolean {
    const tool = this.tool();
    return tool?.kind === 'pencil' && tool.color === color;
  }

  protected isEraserSelected(): boolean {
    return this.tool()?.kind === 'eraser';
  }

  protected togglePencil(color: string) {
    this.tool.set(this.isPencilSelected(color) ? null : { kind: 'pencil', color });
  }

  protected toggleEraser() {
    this.tool.set(this.isEraserSelected() ? null : { kind: 'eraser' });
  }
}
